module.exports = __webpack_public_path__ + "img/Romania.7e4f64d6.svg";